import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DealershipCaseStatus } from 'src/app/shared/enums/dealearship-case-status.enum';
import { CasesCreationInformation } from 'src/app/shared/models/case-creation/case-creation.model';
import { Case, CaseAction, CaseInformation } from 'src/app/shared/models/case.model';

import { BatteryStatus } from '../../shared/models/battery-status.model';
import { SearchedCaseModel } from '../../shared/models/searched-case.model';

@Injectable()
export class CaseService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiUrl = '/api/dealership/cases';

  createCases(bpId: string, casesInformation: CasesCreationInformation): Observable<void> {
    return this.httpClient.post<void>(`${this.apiUrl}?bp-id=${bpId}`, casesInformation);
  }

  getGridCases(bpId: string, caseStatus: DealershipCaseStatus = DealershipCaseStatus.OPEN): Observable<Case[]> {
    return this.httpClient.get<Case[]>(`${this.apiUrl}?bp-id=${bpId}&case-status=${caseStatus}`);
  }

  getOpenCasesBatteryStatuses(bpId: string): Observable<Record<number, BatteryStatus>> {
    return this.httpClient.get<Record<number, BatteryStatus>>(`${this.apiUrl}/battery-status?bp-id=${bpId}`);
  }

  getCase(caseId: number, bpId: string): Observable<CaseInformation> {
    return this.httpClient.get<CaseInformation>(`${this.apiUrl}/${caseId}?bp-id=${bpId}`);
  }

  actionOnCase(caseId: number, bpId: string, action: CaseAction): Observable<void> {
    return this.httpClient.post<void>(`${this.apiUrl}/${caseId}?bp-id=${bpId}`, action);
  }

  deleteCase(caseId: number, bpId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiUrl}/${caseId}?bp-id=${bpId}`);
  }

  updateCase(caseId: number, bpId: string, caseUpdated: Partial<CaseInformation>): Observable<CaseInformation> {
    return this.httpClient.put<CaseInformation>(
      `${this.apiUrl}/${caseId}?scheduler=${false}&bp-id=${bpId}`,
      caseUpdated
    );
  }

  searchCases(vin: string, bpId: string): Observable<SearchedCaseModel[]> {
    const params = new HttpParams().set('bp-id', bpId);
    return this.httpClient.get<SearchedCaseModel[]>(`${this.apiUrl}/${vin}/search-cases`, {
      params,
    });
  }
}
